import { Option } from "@/components/forms/inputs/Autocomplete/types";

export const defaultAutocompleteConverter = ({ value }: { value: unknown | unknown[] }): unknown | unknown[] => {
    if (Array.isArray(value)) {
        return value.map((singleValue) => {
            if (typeof singleValue === "object") {
                return (singleValue as Option).value;
            }

            return singleValue;
        });
    }

    if (typeof value === "object" && value !== null) {
        return (value as Option)?.value;
    }

    return value;
};
